import * as React from 'react';
import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { ListWrapper } from './components/list-wrapper';
import { ListRenderer } from './components/list-renderer';
import { actionCreators } from './actions';
import { experienceTransferTranslation } from '../constants';
import { ExperienceTransferState } from '../types-store';
import { scrollToTop } from 'app/infrastructure/platform/routing';

export type ExperienceTransferListProps = DefaultContainerProps
  & ExperienceTransferState
  & typeof actionCreators;

class ExperienceTransferListComponent extends React.PureComponent<ExperienceTransferListProps> {
  public static statePath: string = STATE.experienceTransfer;

  public componentWillUnmount() {
    this.props.clearList();
  }

  public componentDidMount() {
    scrollToTop();
  }

  public render() {

    const { list, sharedState, translation,
      loadExperienceTransferList, deleteExperienceTransfer, displayError } = this.props;

    return <ListWrapper
      displayError={displayError}
      sharedState={sharedState}
      translation={translation}>
      <ListRenderer
        listState={list}
        loadList={loadExperienceTransferList}
        deleteExperienceTransfer={deleteExperienceTransfer}
        translation={translation} />
    </ListWrapper>;
  }
}

const container = containerFactory(ExperienceTransferListComponent, actionCreators, undefined, experienceTransferTranslation);

export { container as ExperienceTransferList };
